import customSelect from '../../../libs/select/select';
(function ($) {
  $(document).ready(function () {
    var editBtns = document.querySelectorAll('button.edit-btn');
    editBtns.forEach(function (editBtn) {
      editBtn.addEventListener('click', function (event) {
        var target = event.target.firstElementChild;
        var targetRow = event.target.closest('tr.edit-row');
        targetRow.classList.toggle('disable');
        if (target.classList.contains("icon-pen")) {
          target.classList.remove('icon-pen');
          target.classList.add('icon-approve');
        } else {
          target.classList.add('icon-pen');
          target.classList.remove('icon-approve');
        }
      });
    });
  });
})(jQuery);